module.exports = __webpack_public_path__ + "img/icon-save.f121452a.svg";